<template>
  <div class="orders-pay">
    <div class="card">
      <i :class="iconClass"></i>
      <h3>{{ message }}</h3>
      <el-button v-if="payUrl" type="primary" @click="openPay">前往支付页</el-button>
      <p class="meta" v-if="orderId || channelOrderId">
        订单号：<span>{{ orderId || channelOrderId }}</span>
      </p>
    </div>
  </div>
</template>

<script>
// /orders/pay 中转：从我的订单或 welcome task_id=pay 跳转过来
// 调用后端 /ncnp/open/orders/pay-redirect 生成 welcome 跳转 URL
import { ncnpOrderPayRedirect, ncnpOrderStatus } from "@/api/index";

export default {
  name: "OrdersPay",
  data() {
    return {
      message: "正在准备支付",
      payUrl: "",
      orderId: "",
      channelOrderId: "",
      status: "loading",
    };
  },
  computed: {
    iconClass() {
      if (this.status === "success") return "el-icon-circle-check";
      if (this.status === "error") return "el-icon-circle-close";
      return "el-icon-loading";
    },
  },
  async created() {
    const { order_id: orderId, channel_order_id: channelOrderId } = this.$route.query;
    this.orderId = orderId;
    this.channelOrderId = channelOrderId;
    if (!orderId && !channelOrderId) {
      this.status = "error";
      this.message = "缺少订单号";
      return;
    }
    try {
      // 先查一次最新状态，如果已支付直接提示
      const statusRes = await ncnpOrderStatus({ order_id: orderId, channel_order_id: channelOrderId });
      const statusData = statusRes && statusRes.data ? statusRes.data : {};
      if (statusData.status === 1) {
        this.status = "success";
        this.message = "订单已支付完成";
        return;
      }
      const res = await ncnpOrderPayRedirect({ order_id: orderId, channel_order_id: channelOrderId });
      const data = res && res.data ? res.data : {};
      this.payUrl = data.redirectUrl;
      if (this.payUrl) {
        this.message = "即将跳转到支付页";
        window.location.href = this.payUrl;
      } else {
        this.status = "error";
        this.message = "未生成支付链接";
      }
    } catch (e) {
      this.status = "error";
      this.message = "获取支付链接失败";
    }
  },
  methods: {
    openPay() {
      if (this.payUrl) window.location.href = this.payUrl;
    },
  },
};
</script>

<style scoped lang="scss">
.orders-pay {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fb;
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 32px 40px;
  text-align: center;
  min-width: 320px;
  i {
    font-size: 32px;
    color: #1677ff;
  }
  h3 {
    margin: 16px 0 8px;
    font-size: 18px;
  }
  .meta {
    margin-top: 16px;
    color: #86909c;
    font-size: 12px;
    span {
      color: #1677ff;
    }
  }
  .el-icon-circle-close {
    color: #f56c6c;
  }
}
</style>
